import React from "react";

/**
 * Checkbox. Renders label wrapper by default.
 * @param {Object} props
 * @param {string} props.label
 */
export function Checkbox({ label, ...rest }) {
  return (
    <label className="ds-checkbox">
      <input type="checkbox" {...rest} />
      {label}
    </label>
  );
}
